import { MapPin } from "lucide-react";
import { AREAS } from "../data/site";
import { Reveal } from "./Reveal";

export default function Areas() {
  return (
    <section id="areas" className="py-24 sm:py-32 bg-[#0D0D0D]" data-testid="areas-section">
      <div className="container-lux grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="overline mb-3">Areas We Cover</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight mb-5">
            Proudly serving <span className="text-gold-metallic">Greater Manchester &amp; Cheshire.</span>
          </h2>
          <p className="text-[#C8C8C8] mb-8">Based in Poynton, we work throughout the region. If your town isn&apos;t listed, get in touch — we very likely cover you.</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {AREAS.map((a, i) => (
              <Reveal key={a} delay={i * 0.04}>
                <div className="flex items-center gap-2 glass rounded-sm px-4 py-3 hover:border-[#D4AF37]/50 transition-colors">
                  <MapPin size={15} className="text-[#D4AF37] shrink-0" strokeWidth={1.5} />
                  <span className="text-sm">{a}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="rounded-md overflow-hidden border border-white/10 h-[440px]">
            <iframe
              title="Sterling Roofworks coverage map"
              data-testid="areas-map"
              className="w-full h-full grayscale contrast-125"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=Poynton,Cheshire,SK12+1NQ&z=10&output=embed"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
